import { LIMITS, DEFAULT_CONFIGS } from './limits';

// Question type constants
export const QUESTION_TYPES = {
  SHORT_TEXT: 'SHORT_TEXT',
  PARAGRAPH: 'PARAGRAPH',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  CHECKBOX: 'CHECKBOX',
  DROPDOWN: 'DROPDOWN',
  STATEMENT: 'STATEMENT',
  FIVE_STAR_REVIEW: 'FIVE_STAR_REVIEW',
  DATE_PICKER: 'DATE_PICKER',
  FILE_UPLOAD: 'FILE_UPLOAD',
  // Add new question types here
};

// Question type configurations

export const QUESTION_CONFIGS = {
  [QUESTION_TYPES.SHORT_TEXT]: {
    label: 'Short Answer',
    icon: '📝',
    hasOptions: false,
    hasMinMax: true,
    defaultConfig: DEFAULT_CONFIGS.SHORT_TEXT,
    limits: {
      minLen: LIMITS.SHORT_TEXT_MIN_LEN_LOWER,
      maxLen: LIMITS.SHORT_TEXT_MAX_LEN_UPPER,
    },
  },
  [QUESTION_TYPES.PARAGRAPH]: {
    label: 'Paragraph',
    icon: '📄',
    hasOptions: false,
    hasMinMax: true,
    defaultConfig: DEFAULT_CONFIGS.PARAGRAPH,
    limits: {
      minLen: LIMITS.PARAGRAPH_MIN_LEN_LOWER,
      maxLen: LIMITS.PARAGRAPH_MAX_LEN_UPPER,
    },
  },
  [QUESTION_TYPES.MULTIPLE_CHOICE]: {
    label: 'Multiple Choice',
    icon: '🔘',
    hasOptions: true,
    hasMinMax: false,
    hasSelections: false, // Don't show selection controls
    defaultConfig: DEFAULT_CONFIGS.MULTIPLE_CHOICE,
    limits: {
      maxOptions: LIMITS.MCQ_OPTIONS_UPPER,
    },
  },
  [QUESTION_TYPES.CHECKBOX]: {
    label: 'Checkboxes',
    icon: '☑️',
    hasOptions: true,
    hasMinMax: false,
    hasSelections: true, // Show selection controls
    defaultConfig: DEFAULT_CONFIGS.CHECKBOX,
    limits: {
      maxOptions: LIMITS.CHECKBOX_OPTIONS_UPPER,
    },
  },
  [QUESTION_TYPES.DROPDOWN]: {
    label: 'Dropdown',
    icon: '📋',
    hasOptions: true,
    hasMinMax: false,
    hasSelections: false, // Don't show selection controls
    defaultConfig: DEFAULT_CONFIGS.DROPDOWN,
    limits: {
      maxOptions: LIMITS.DROPDOWN_OPTIONS_UPPER,
    },
  },
  [QUESTION_TYPES.STATEMENT]: {
    label: 'Statement',
    icon: 'ℹ️',
    hasOptions: false,
    hasMinMax: false,
    hasSelections: false,
    defaultConfig: null,
  },
  [QUESTION_TYPES.FIVE_STAR_REVIEW]: {
    label: 'Five Star Review',
    icon: '⭐',
    hasOptions: false,
    hasMinMax: false,
    hasSelections: false,
    defaultConfig: null,
  },
  [QUESTION_TYPES.DATE_PICKER]: {
    label: 'Date',
    icon: '📅',
    hasOptions: false,
    hasMinMax: false, // It has its own min/max date config, not length
    hasSelections: false,
    defaultConfig: {
      minDate: null,
      maxDate: null,
    },
  },
  [QUESTION_TYPES.FILE_UPLOAD]: {
    label: 'File Upload',
    icon: '📎',
    hasOptions: false,
    hasMinMax: false,
    hasSelections: false,
    defaultConfig: {
      supportedFileTypes: [],
    },
  },
};
